import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CheckIcon from '@material-ui/icons/Check';
import handleOpenWhatsApp from 'services/whatsappService';
import {
  GUOMEI,
  webNextSteps,
  WHATSAPP_WEB_DEFAULT,
  WHATSAPP_PHONE,
} from '../guomeiContent';
import { copyText } from '../copyText';

const WebNextSteps = () => {
  const [copiedEmail, setCopiedEmail] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await copyText(webNextSteps.driveEmail);
      setCopiedEmail(true);
      window.setTimeout(() => setCopiedEmail(false), 1800);
    } catch (err) {
      // clipboard may be blocked
    }
  };

  return (
    <Box
      component="section"
      id="siguientes-pasos"
      py={{ xs: 7, md: 10 }}
      px={{ xs: 2.5, sm: 4, md: 7 }}
      bgcolor={GUOMEI.sandDeep}
    >
      <Box maxWidth={1100} mx="auto">
        <Typography
          sx={{
            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
            fontWeight: 700,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            color: GUOMEI.lagoon,
            mb: 1.25,
          }}
        >
          {webNextSteps.overline}
        </Typography>
        <Typography
          component="h2"
          sx={{
            fontFamily: '"Fraunces", "Georgia", serif',
            fontWeight: 700,
            fontSize: { xs: '1.85rem', md: '2.55rem' },
            color: GUOMEI.ink,
            mb: 1.25,
            maxWidth: 640,
          }}
        >
          {webNextSteps.title}
        </Typography>
        <Typography
          sx={{
            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
            color: GUOMEI.inkMuted,
            fontSize: { xs: '1.05rem', md: '1.12rem' },
            lineHeight: 1.65,
            maxWidth: 560,
            mb: { xs: 4, md: 5 },
          }}
        >
          {webNextSteps.subtitle}
        </Typography>

        <Grid container spacing={3} mb={4}>
          {webNextSteps.steps.map((step) => (
            <Grid item xs={12} md={step.materials ? 12 : 6} key={step.id}>
              <Box>
                <Typography
                  sx={{
                    fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                    fontWeight: 800,
                    fontSize: { xs: '2.5rem', md: '3rem' },
                    color: GUOMEI.lagoonSoft,
                    opacity: 0.4,
                    lineHeight: 1,
                    mb: 1,
                  }}
                >
                  {step.n}
                </Typography>
                <Typography
                  component="h3"
                  sx={{
                    fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                    fontWeight: 800,
                    fontSize: '1.35rem',
                    color: GUOMEI.ink,
                    mb: 1,
                  }}
                >
                  {step.title}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                    color: GUOMEI.inkMuted,
                    lineHeight: 1.7,
                    fontSize: '1.02rem',
                    maxWidth: step.materials ? 720 : 'none',
                  }}
                >
                  {step.text}
                </Typography>

                {step.materials ? (
                  <Box mt={2.5}>
                    <Box
                      display="flex"
                      alignItems="center"
                      flexWrap="wrap"
                      mb={2}
                      sx={{ gap: 1.25 }}
                    >
                      <Typography
                        sx={{
                          fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          color: GUOMEI.ink,
                        }}
                      >
                        Comparte la carpeta con
                      </Typography>
                      <Box
                        display="inline-flex"
                        alignItems="center"
                        px={1.5}
                        py={0.75}
                        borderRadius={1.25}
                        bgcolor={GUOMEI.white}
                        border={`1px solid ${copiedEmail ? GUOMEI.lagoon : GUOMEI.sand}`}
                        sx={{ gap: 1 }}
                      >
                        <Typography
                          sx={{
                            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                            fontWeight: 700,
                            color: GUOMEI.ocean,
                            fontSize: '0.98rem',
                          }}
                        >
                          {webNextSteps.driveEmail}
                        </Typography>
                        <Button
                          type="button"
                          size="small"
                          variant={copiedEmail ? 'contained' : 'outlined'}
                          startIcon={
                            copiedEmail ? <CheckIcon /> : <FileCopyOutlinedIcon />
                          }
                          onClick={handleCopyEmail}
                          sx={{
                            borderRadius: 1.25,
                            fontWeight: 800,
                            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                            textTransform: 'none',
                            px: 1.5,
                            borderColor: GUOMEI.lagoon,
                            color: copiedEmail ? GUOMEI.white : GUOMEI.lagoon,
                            bgcolor: copiedEmail ? GUOMEI.lagoon : 'transparent',
                            '&:hover': {
                              borderColor: GUOMEI.ocean,
                              bgcolor: copiedEmail ? GUOMEI.ocean : GUOMEI.white,
                              color: copiedEmail ? GUOMEI.white : GUOMEI.ocean,
                            },
                          }}
                        >
                          {copiedEmail ? 'Copiado' : 'Copiar'}
                        </Button>
                      </Box>
                    </Box>

                    <Typography
                      sx={{
                        fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                        fontWeight: 700,
                        fontSize: '0.85rem',
                        letterSpacing: '0.04em',
                        textTransform: 'uppercase',
                        color: GUOMEI.lagoon,
                        mb: 1.25,
                      }}
                    >
                      Incluye en la carpeta
                    </Typography>
                    <Box
                      component="ul"
                      sx={{
                        m: 0,
                        pl: 2.25,
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                        gap: 1,
                      }}
                    >
                      {step.materials.map((item) => (
                        <Typography
                          component="li"
                          key={item}
                          sx={{
                            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                            color: GUOMEI.inkMuted,
                            lineHeight: 1.55,
                            fontSize: '0.98rem',
                          }}
                        >
                          {item}
                        </Typography>
                      ))}
                    </Box>
                  </Box>
                ) : null}
              </Box>
            </Grid>
          ))}
        </Grid>

        <Button
          variant="contained"
          size="large"
          startIcon={<WhatsAppIcon />}
          onClick={() => handleOpenWhatsApp(null, WHATSAPP_WEB_DEFAULT, WHATSAPP_PHONE)}
          sx={{
            px: 3.5,
            py: 1.5,
            borderRadius: 1.5,
            fontWeight: 800,
            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
            bgcolor: GUOMEI.ocean,
            color: GUOMEI.white,
            boxShadow: '0 14px 32px rgba(11,61,74,0.28)',
            '&:hover': { bgcolor: GUOMEI.oceanDeep },
          }}
        >
          {webNextSteps.cta}
        </Button>

        <Typography
          sx={{
            mt: 5,
            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
            fontSize: '0.85rem',
            color: GUOMEI.inkMuted,
          }}
        >
          {webNextSteps.copyright}
        </Typography>
      </Box>
    </Box>
  );
};

export default WebNextSteps;
